import React, { useState, useEffect } from 'react';
import './example.css';

function NavMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Start with menu closed

  // Toggles the menu state
  const toggleMenu = () => {
    console.log(`Menu button clicked. Current state: ${isMenuOpen ? 'Open' : 'Closed'}`);
    setIsMenuOpen((prev) => !prev);
  };

  // Trigger menu to open after page loads
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMenuOpen(true); // Open the menu after a delay
    }, 650); // Adjust the delay as needed (250ms in this example)

    return () => clearTimeout(timer); // Cleanup timer on component unmount
  }, []);

  return (
    <div
      className="navigation-menu"
      data-mode={isMenuOpen ? 'menu' : 'closed'}
      data-centered=""
    >
      <div className="navigation-menu__header">
        {/* Site Title / Logo */}
        <a
          href="/"
          id="site-title"
          className="button logo"
          target="_self"
          rel="noopener noreferrer"
        >
          S<br></br>u<br></br>s<br></br>h<br></br>i
        </a>

        {/* Main nav#menu */}
        <nav id="menu" className={isMenuOpen ? 'expanded' : 'collapsed'}>
          <div className="inner">
            <a
              className="button navigation-link"
              href="#popups"
              data-size="1/2"
            >
              Careers
            </a>
            <a
              className="button navigation-link"
              href="#creative-events"
              data-size="1/2"
            >
              Catering
            </a>
            <a
              className="button navigation-link"
              href="mailto:brian@briantwagner.com"
              data-size="1/3"
              target="_blank"
              rel="noopener"
            >
              Contact 
            </a>
            <a className="button navigation-link" href="#about" data-size="1/3">
              About
            </a>
            <a
              className="button navigation-link"
              href="#instagram"
              data-size="1/3"
              target="_blank"
              rel="noopener"
            >
              Instagram
            </a>
            <a className="button navigation-link" href="#talents" data-size="1/2">
              Talents
            </a>
            <a className="button navigation-link" href="#food" data-size="1/2">
              Food
            </a>
          </div>
        </nav>

        {/* Back button */}
        <a
          id="back"
          className="button cursor-pointer"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? (
            <>
              C<br></br>l<br></br>o<br></br>s<br></br>e
            </>
          ) : (
            <>
              M<br></br>e<br></br>n<br></br>u
            </>
          )}
        </a>
      </div>
    </div>
  );
}

export default NavMenu;